import React, { Component } from 'react';
import PropTypes from 'prop-types';
import confetti from '../confetti';

export default class Confetti extends Component {
  componentDidMount() {
    const { resource } = this.props;
    const canvas = `canvas-${resource._id}`; // eslint-disable-line no-underscore-dangle
    confetti(canvas);
  }

  render() {
    const { resource } = this.props;
    const canvas = `canvas-${resource._id}`; // eslint-disable-line no-underscore-dangle
    return <canvas id={canvas}></canvas>;
  }
}

Confetti.propTypes = { resource: PropTypes.object };
